export const UNKNOWN_ERROR_MSG = 'something went wrong';
export const NOT_IMPLEMENTED_MSG = 'not implemented';
export const MISSING_DATA_MSG = 'missing data';
